import * as React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { PrimaryCta } from 'components/Buttons';
import {
  NotificationModal,
  useOpenNotificationModal,
  useCloseNotificationModal
} from 'catering/components/Modals';
import { formatAddItemInventoryErrorMessageForModal } from 'catering/helpers';

function MenuItemInventoryNotification({ message }) {
  const close = useCloseNotificationModal();
  const { title, text } = formatAddItemInventoryErrorMessageForModal(message);

  return (
    <NotificationModal title={title} text={text}>
      <Box sx={{ padding: '30px 0 5px 0' }}>
        <PrimaryCta label="OK, GOT IT" handleClick={close} fullWidth />
      </Box>
    </NotificationModal>
  );
}

MenuItemInventoryNotification.propTypes = {
  message: PropTypes.string.isRequired
};

export function useOpenMenuItemInventoryNotificationModal() {
  return useOpenNotificationModal(<MenuItemInventoryNotification />);
}
